<template>
    <div class="contactWidget-form">
        <div class="contactWidget-title">
            Заказ обратного звонка <i class="icon-close" @click="closeWidget"/>
        </div>
        <div class="contactWidget-wrap">
            <div class="contactWidget-inputItem" v-for="(item, index) in inputs" :key="index+'e'">
                <div class="contactWidget-inputTitle">
                    {{item.holderInput}}
                </div>
                <reg-input
                    :pattern="item.patternInput"
                    :value="item.value"
                    :valid="false"
                    :active="item.active"
                    @input="onInput(index, $event)"
                    :styleClass="'contactWidget-formInput'"
                ></reg-input>
            </div>
        </div>
        <div class="contactWidget-wrap">
            <div class="contactWidget-desc">На указаный адрес мы вышлем<br>письмо с деталями и возможностями</div>
            <div class="contactWidget-desc color-red" v-if="errorMsg">Пожайлуста, заполните все поля формы</div>
            <div class="contactWidget-desc color-green" v-if="successMsg">Ваш запрос отправлен. Мы скоро свяжемся в Вами!</div>
            <div @click="sendMail()" class="contactWidget-submit">Отправить</div>
        </div>
    </div>
</template>
<script>
import Input from './reg-input';
import { mapGetters } from "vuex";
import axios from 'axios';
export default {
    props: {
        manager:{default:'vd@iqquantum.com'},
        type:{default:'invest'}
    },
    components: {
        'reg-input':Input
    },
    data() {
        return {
            inputs: [
                    {
                        holderInput: 'Укажите ФИО',
                        patternInput: /.+/,
                        value: '',
                        active:false
                    },
                    {
                        holderInput: 'Укажите номер телефона',
                        patternInput: /^\d+$/,
                        value: '',
                        active:false
                    },
                    {
                        holderInput: 'Укажите E-mail',
                        patternInput: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        value: '',
                        active:false
                    }
                ],
            doneInput:0,
            successMsg:false,
            errorMsg:false,
        }
    },
    computed: {
        ...mapGetters(
            {
                apiUri:'api/getApiUri'
            }
        )
    },
    methods: {
        onInput(index, data) {
            this.inputs[index].value = data.value;
            //this.inputs[index].valid = data.completed;
            this.inputs[index].active = data.activate;
            let done = 0;
            for(let i = 0; i < this.inputs.length; i++) {
                if (this.inputs[i].value !== '')
                    done++
            }
            this.doneInput = done;
        },
        sendMail() {
            if(this.doneInput !== this.inputs.length) {
                this.errorMsg = true;
                this.successMsg = false;
                return
            }
            axios
                .get(this.apiUri + 'email/callback?type=' + this.type + '&manager=' + this.manager + '&phone=' + this.inputs[1].value + '&email=' + this.inputs[2].value + '&name=' + this.inputs[2].value)
                .then(response => {
                    if(response.data === 'success')
                        this.successMsg = true;
                        this.errorMsg = false;
                })
                .catch(error => console.log(error));
        },
        closeWidget() {
            this.$emit('closeWidget')
        }
    }
}
</script>
<style lang="less" scoped>
input[type="text"]::placeholder { color: #CCE0F8; } 
.contactWidget {
    flex-direction: column;
    overflow: hidden;
    &:last-child {
        margin-bottom: 0px;
    }
    &-wrap {
        padding: 0 20px 20px 20px;
    }
    &-inputTitle {
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        color: #ffffff;
    }
    &-inputItem {
        margin-top: 28px;
    }
    &-desc {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #ADC4E1;
        margin-top: 3px;
    }
    &-submit {
        height: 42px;
        border-radius: 5px;
        background-color: #00ffd0;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        color: #46607b;
        text-transform: uppercase;
        text-align:center;
        margin-top: 30px;
        cursor: pointer;
    }
    &-title {
        height: 40px;
        display: flex;
        justify-content: space-between;
        font-family: Arimo;
        font-size: 19px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.11;
        letter-spacing: 0.4px;
        color: #ffffff;
        padding-left: 20px;
        border-bottom: 3px solid #3d536b;
        i {
            color:#718DA8;
            cursor: pointer;
            margin-right: 14px;
        }
    }
    &-titleText {
        display: flex;
        align-items: center;
        i {
            color:#fff;
            font-size: 24px;
            margin-right: 8px;
            margin-bottom: -4px;
        }
    }
    &-form {
        display: flex;
        flex-direction: column;
        background: #465f7a;
        width:420px;
        box-sizing: border-box;
    }
    &-formInput {
        width: 100%;
        border-radius: 6px;
        border: solid 1px #718aa0;
        font-family: Arimo;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        color: #adc4e1;
        padding-bottom: 4px;
        outline: none;
        height: 40px;
        /* identical to box height, or 127% */
    }
    &-dataItem {
        padding: 12px;
    }
    &-dataText {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #FFFFFF;
        &_title {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 20px;
            color: #ADD4E1;
        }
    }
    &-dataWrap {
        z-index: 0;
        overflow: hidden;
    }
}
</style>
